import React from "react";

const Social = () => {
    return (<div className='home__social opacity'>
        <a href="https://www.linkedin.com/in/alina-olieinik/" target='_blank' rel="noreferrer"
           className='home__social-icon'>
            <i className='bx bxl-linkedin'></i>
        </a>
        <a href="https://t.me/oleinikalina" target='_blank' rel="noreferrer" className='home__social-icon'>
            <i className='uil uil-telegram'></i>
        </a>
       
        <a href="mailto:poadeda@gmail.com" target='_blank' rel="noreferrer" className='home__social-icon'>
            <i className="bx bx-envelope contact__cars-icon"></i>
        </a>
    </div>)
}

export default Social;